// extracted by mini-css-extract-plugin
export var error = "error-module--error--d7bbe";
export var errorEmpty = "error-module--error--empty--f7e8f";
export var mt0 = "error-module--mt-0--82de9";
export var mt1 = "error-module--mt-1--4f80d";
export var mt2 = "error-module--mt-2--a74c8";
export var mt3 = "error-module--mt-3--2cceb";
export var mt4 = "error-module--mt-4--d4b26";
export var mt5 = "error-module--mt-5--f3d7c";
export var mt6 = "error-module--mt-6--84cf6";